import { UpdateListSortProps } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

export const updateListSort = async(requestBody: UpdateListSortProps) => {
  // TODO: test what this does as far as errors -> const requestBody2 = null; //
  return await api.put(`/list-sorts/${requestBody.listSortIdToEdit}`, requestBody);
};
